import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Business from "./pages/Business";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import About from "./pages/About";
import ScrollToTop from "./components/ScrollToTop";
import Blogs from "./pages/Blogs";
import ViewBlog from "./pages/ViewBlog";
import Team from "./pages/Team";

function Layout() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      {/* All routes go here */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/business" element={<Business/>} />
        <Route path="/blogs" element={<Blogs/>} />
         <Route path="/team" element={<Team/>} />
        <Route path="/view-content/:id" element={<ViewBlog/>} />
      </Routes>
      <Footer />
    </Router>
  )
}

export default Layout